// Google Maps pesa ~400 KB: se carga hasta la primera interacción del
// visitante (o 5 s después de cargar la página) para no frenar la carga inicial.
// Al terminar de cargar llama a initMap (definida en envio.js).
(function () {
    const MAPS_URL = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBK3VjQGT_xKrO3EmettNxTLhO4gZ2GJe0&libraries=places,geometry&callback=initMap';
    const eventos = ['pointerdown', 'keydown', 'scroll', 'touchstart'];
    let cargado = false;

    function cargarMaps() {
        if (cargado) return;
        cargado = true;
        eventos.forEach(e => window.removeEventListener(e, cargarMaps));
        const script = document.createElement('script');
        script.src = MAPS_URL;
        script.async = true;
        document.head.appendChild(script);
    }

    eventos.forEach(e => window.addEventListener(e, cargarMaps, { once: true, passive: true }));
    window.addEventListener('load', () => setTimeout(cargarMaps, 5000));
})();
